import { useEffect, useRef, useState } from "react";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

import { subscribeToToasts } from "services/toastService";

const ToastHost = () => {
    const [toasts, setToasts] = useState([]);
    const timeoutsRef = useRef(new Map());

    useEffect(() => {
        const removeToast = (toastId) => {
            setToasts((prev) => prev.filter((toast) => toast.id !== toastId));
            const timeoutId = timeoutsRef.current.get(toastId);
            if (timeoutId) {
                clearTimeout(timeoutId);
                timeoutsRef.current.delete(toastId);
            }
        };

        const unsubscribe = subscribeToToasts((toast) => {
            setToasts((prev) => [...prev, toast]);

            const timeoutId = setTimeout(() => {
                removeToast(toast.id);
            }, toast.duration ?? 4000);

            timeoutsRef.current.set(toast.id, timeoutId);
        });

        return () => {
            unsubscribe();
            timeoutsRef.current.forEach((timeoutId) => {
                clearTimeout(timeoutId);
            });
            timeoutsRef.current.clear();
        };
    }, []);

    const handleClose = (toastId) => (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setToasts((prev) => prev.filter((toast) => toast.id !== toastId));
        const timeoutId = timeoutsRef.current.get(toastId);
        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutsRef.current.delete(toastId);
        }
    };

    return (
        <>
            {toasts.map((toast, index) => (
                <Snackbar
                    key={toast.id}
                    open
                    onClose={handleClose(toast.id)}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    style={{ bottom: 16 + index * 72 }}
                    data-testid="toast-snackbar"
                >
                    <Alert
                        onClose={handleClose(toast.id)}
                        severity={toast.severity ?? "info"}
                        variant="filled"
                    >
                        {toast.message}
                    </Alert>
                </Snackbar>
            ))}
        </>
    );
};

export default ToastHost;
